function alertParameterPriceCodeController(alertsFrameworkService, priceCodeService) {
	const $ctrl = this;

	$ctrl.arePriceCodesLoading = false;

	$ctrl.$onInit = function () {
		loadPriceCodes();

		$ctrl.priceCodeKeys = alertsFrameworkService.getKeyArrayFromCsv($ctrl.model);
	};

	/* Handle Model Changes on the Parent */
	$ctrl.$onChanges = function(changes) {
		if (changes.model){
			const newKeys = alertsFrameworkService.getKeyArrayFromCsv(changes.model.currentValue);
			const arraysEqual = 
				newKeys.length === $ctrl.priceCodeKeys.length 
				&& newKeys.every((value, index) => value === $ctrl.priceCodeKeys[index]);

			if (!arraysEqual)
			{
				$ctrl.priceCodeKeys = newKeys;
			}        
		}		
    }

	$ctrl.priceCodesChanged = (item, model) => {
        const csvValue = alertsFrameworkService.getCsvFromKeyArray($ctrl.priceCodeKeys);
		
		$ctrl.onUpdate({csvValue: csvValue});
	};

	function loadPriceCodes() {
		$ctrl.arePriceCodesLoading = true;

		return priceCodeService
			.getBasePriceCodes($ctrl.subscriberKey)
			.then((priceCodes) => {

				$ctrl.priceCodes = priceCodes.toSorted((a, b) => {
                    const nameA = a.basePriceCodeName.toUpperCase();
                    const nameB = b.basePriceCodeName.toUpperCase();

                    if (nameA < nameB) {
                        return -1;
                    }

                    if (nameA > nameB) {
                        return 1;
                    }

                    return 0;
                });

				function getDisplayName(basePriceCodeId, basePriceCodeName) {
					/* Id - Name */
					if (basePriceCodeId && basePriceCodeName) {
						return `${basePriceCodeId} - ${basePriceCodeName}`;
					} 
					
					/* Id */
					if (basePriceCodeId && !basePriceCodeName) {
						return basePriceCodeId;
					}

					/* (Blanks) */
					return '(Blanks)';
				}

				$ctrl.priceCodes.forEach(priceCode => {
					priceCode.displayName = getDisplayName(priceCode.basePriceCodeId, priceCode.basePriceCodeName);
				})
                
				$ctrl.arePriceCodesLoading = false;
			});
	}
}

angular
	.module("angus.components")
	.component("alertParameterPriceCode", {
		controller: alertParameterPriceCodeController,
		bindings: {
			subscriberKey: "<",
			label: "<",
			model: "<",
			isReadOnly: "<",
			onUpdate: "&"
		},
		template: `
<label class="control-label" for="priceCodes">{{$ctrl.label || 'Price Code'}}
    <i class="fa fa-spinner fa-spin" data-fade-toggle="arePriceCodesLoading"></i></label>

<ui-select
    class="alert-select" 
	multiple 
	ng-model="$ctrl.priceCodeKeys" 
	ng-disabled="!$ctrl.priceCodes.length || $ctrl.isReadOnly" 
	on-select="$ctrl.priceCodesChanged($item, $model)" 
	on-remove="$ctrl.priceCodesChanged($item, $model)"
>
    <ui-select-match placeholder="Select price codes...">{{$item.displayName || '(Blanks)'}}</ui-select-match>
    <ui-select-choices repeat="priceCode.basePriceCodeKey as priceCode in $ctrl.priceCodes | filter: {displayName: $select.search}">
        {{priceCode.displayName || '(Blanks)'}}</ui-select-choices>
</ui-select>
		`
	});
